import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  flex-direction: row;
  @media (max-width: 1100px){
    flex-direction: row;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  color: #000FFF;
  cursor: pointer;
`;

export const ItemDetails = styled.span`
  color: #808080;
  font-size: 11px;
  font-weight: 300;
`;


export const DownloadIcon = styled.i`
  cursor: pointer;
  color: #487cf5;
  font-size: 25px;
`;

export const Divisor = styled.div`
  width: 1px;
  height: 51px;
  background-color: #707070;
  margin-left: 15px;
  margin-right: 15px;
  @media (max-width: 768px){
    visibility: hidden;
  }
`

export const Details = styled.div`
  margin-left: 24px;
  padding: 0px 10px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000FFF;
  color: #FFF;
  font-size: 12px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;
`

export const IconInformation = {
  width: 10,
  height: 10,
  marginLeft: 5
}

export const Left = styled.div`
  cursor: pointer;
  margin-left: 23px;
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:row;
  @media (max-width: 1100px){
    justify-content:flex-start;
  }
`

export const Right = styled.div`
  display:flex;
  justify-content:space-between;
  align-items:center;
  flex-direction:row;
  @media (max-width: 1100px){
    justify-content:flex-end;
  }
`
export const DownloadButton = styled.div`
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 200px;
`

export const BoxTitle = styled.div`
  width: 150px;
`
